
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","d":"M14.416 1h11.5M14.416 7.199h7.379M14.416 13.398h4.565M14.416 19.598h2.154M6.35 1.029v16.038"}}),_c('path',{attrs:{"d":"M6.097 20.467a.4.4 0 00.59 0l3.852-4.19a.4.4 0 00-.295-.671H2.54a.4.4 0 00-.295.67l3.853 4.19z","fill":"currentColor"}})])
          )
        }
      }
    